<template>
    <div class="b-table-sticky-header table-responsive">
        <b-table-simple
            no-border-collapse
        >
            <b-thead>
                <b-tr>
                    <b-th
                        class="text-left"
                    >
                        {{ $t('v4.Type') }}
                    </b-th>
                    <b-th
                        class="text-left"
                    >
                        {{ $t('v4.Description') }}
                    </b-th>
                    <b-th
                        class="text-right"
                    >
                        {{ $t('v4.Qty') }}
                    </b-th>
                    <b-th
                        class="text-right"
                    >
                        {{ $t('v4.Cost') }}
                    </b-th>
                </b-tr>
            </b-thead>
            <b-tbody v-if="tableData.length">
                <b-tr
                    v-for="(html, index) in tableData"
                    :key="index"
                    v-html="html"
                >
                </b-tr>
            </b-tbody>
            <b-tbody v-else>
                <b-tr>
                    <b-td colspan="4" class="pb-50 pt-2 text-center">
                        <SVGEmptyIcon/>
                        <div>

                            {{ $t("org.message.No Data") }}
                        </div>
                    </b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple>
    </div>
</template>

<script>
import { getCurrentInstance, computed, toRefs } from '@vue/composition-api'
import useCommonData from '@/composables/useCommonData'
import SVGEmptyIcon from '@/assets/images/empty.svg'
export default {
    components: {
        SVGEmptyIcon
    },
    props: {
        data: {
            type: Array,
            default: function () {
                return []
            }
        }
    },
    setup (props, context) {
        const vm = getCurrentInstance().proxy
        const rightIconHtml = '<i class="fas fa-long-arrow-alt-right"></i>'
        const leftIconHtml = '<i class="fas fa-long-arrow-alt-left"></i>'
        const { region } = useCommonData()
        const { data } = toRefs(props)
        const regionMap = computed(() => {
            return region.value.reduce((accumulator, currentValue) => {
                accumulator[currentValue.key] = currentValue
                return accumulator
            }, {})
        })
        const transflowTableData = (array) => {
            const list = []
            const data = array.slice().reduce((accumulator, currentValue) => {
                const usageTypeArray = currentValue.usageType.split('-')
                const region = usageTypeArray.length === 4 && regionMap.value[usageTypeArray[0]] ? regionMap.value[usageTypeArray[0]].name : 'Virginia'
                let item = {}
                if (~currentValue.usageType.indexOf('DataTransfer-In-Bytes')) {
                    item = {
                        key: `${region}<-WWW`,
                        typeHtml: `${region} ${leftIconHtml} WWW`,
                        ...currentValue
                    }
                } else if (~currentValue.usageType.indexOf('DataTransfer-Out-Bytes')) {
                    item = {
                        key: `${region}->WWW`,
                        typeHtml: `${region} ${rightIconHtml} WWW`,
                        ...currentValue
                    }
                } else if (~currentValue.usageType.indexOf('DataTransfer-Regional-Bytes')) {
                    item = {
                        key: `${region} Regional`,
                        typeHtml: `${region} Regional`,
                        ...currentValue
                    }
                } else if (currentValue.productCategory === 'Amazon Data Transfer Multi Region' && ~currentValue.usageType.indexOf('Out-Bytes')) {
                    const origin = regionMap.value[usageTypeArray[0]] && regionMap.value[usageTypeArray[1]] ? regionMap.value[usageTypeArray[0]].name : usageTypeArray[0]
                    const destination = regionMap.value[usageTypeArray[0]] && regionMap.value[usageTypeArray[1]] ? regionMap.value[usageTypeArray[1]].name : usageTypeArray[1]
                    item = {
                        key: `${origin}->${destination}`,
                        typeHtml: `${origin} ${rightIconHtml} ${destination}`,
                        ...currentValue
                    }
                } else if (currentValue.productCategory === 'Amazon Data Transfer Multi Region' && ~currentValue.usageType.indexOf('In-Bytes')) {
                    const destination = regionMap.value[usageTypeArray[0]] && regionMap.value[usageTypeArray[1]] ? regionMap.value[usageTypeArray[0]].name : usageTypeArray[0]
                    const origin = regionMap.value[usageTypeArray[0]] && regionMap.value[usageTypeArray[1]] ? regionMap.value[usageTypeArray[1]].name : usageTypeArray[1]
                    item = {
                        key: `${destination}<-${origin}`,
                        typeHtml: `${destination} ${leftIconHtml} ${origin}`,
                        ...currentValue
                    }
                } else if (~currentValue.usageType.indexOf('CloudFront-In-Bytes')) {
                    item = {
                        key: `${region}<-CloudFront`,
                        typeHtml: `${region} ${leftIconHtml} CloudFront`,
                        ...currentValue
                    }
                } else if (~currentValue.usageType.indexOf('CloudFront-Out-Bytes')) {
                    item = {
                        key: `${region}->CloudFront`,
                        typeHtml: `${region} ${rightIconHtml} CloudFront`,
                        ...currentValue
                    }
                } else {
                    item = {
                        typeHtml: currentValue.usageType,
                        ...currentValue
                    }
                }
                if (!accumulator[currentValue.productCategory]) {
                    accumulator[currentValue.productCategory] = {}
                }
                if (!accumulator[currentValue.productCategory][item.key]) {
                    accumulator[currentValue.productCategory][item.key] = []
                }
                if (accumulator[currentValue.productCategory]) {
                    accumulator[currentValue.productCategory][item.key].push(item)
                }
                return accumulator
            }, {})
            for (let category in data) {
                list.push(`<td colspan="4"><b>${category}</b></td>`)
                const items = data[category]
                for (let key in items) {
                    items[key].map((item, index) => {
                        let html = ''
                        if (index === 0) {
                            html += `<td class="text-nowrap" rowspan=${items[key].length}>${item.typeHtml}</td>`
                        }
                        html += `<td>${item.lineItemDescription}</td>
                                <td class="text-right text-nowrap" style="width:110px;">${vm.$_getAmount(item.usageAmount, 'DataTransfer')}</td>
                                <td class="text-right text-nowrap" style="width:110px;">${vm.$_getDollar(item.cost)}</td>`
                        list.push(html)
                    })
                }
            }
            return list
        }
        const tableData = computed(() => transflowTableData(data.value))
        return {
            rightIconHtml,
            leftIconHtml,
            transflowTableData,
            regionMap,
            tableData
        }
    }
}
</script>

<style>

</style>
